export default __webpack_public_path__ + "img/a0e633374829426ab518b4ea4129d63c.svg";